import axios from "axios";
import productFallback from "../assets/images/product1.png";
import { BaseUrl } from "../config/api";

export const toHttps = (url) => {
  if (!url) return null;
  if (typeof url !== "string") return null;
  // Keep absolute URLs as-is (including local HTTP in development)
  if (url.startsWith("https://") || url.startsWith("http://")) return url;
  // For relative paths, prepend BaseUrl
  const base = BaseUrl ? String(BaseUrl).replace(/\/$/, "") : "";
  if (url.startsWith("/")) return base + url;
  return base + "/" + url;
};

export const fetchImageWithAuth = async (imageUrl) => {
  try {
    const httpsUrl = toHttps(imageUrl);
    const response = await axios.get(httpsUrl, {
      headers: {
        Authorization: "QuindlTokPATFileUpload2025#$$TerOiu$",
      },
      responseType: "arraybuffer",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching image over HTTPS:", error);
    if (imageUrl && imageUrl.startsWith("http://")) {
      console.warn(
        "Image source uses HTTP and was blocked by the browser. Serve images over HTTPS or proxy them through your backend."
      );
    }
    return null;
  }
};

// Product image fallback handler
export const handleProductImageError = (e) => {
  e.target.src = productFallback;
  e.target.onerror = null; // Prevent infinite loop
};

export { productFallback };
